import dayjs from 'dayjs';
import 'dayjs/locale/nb';
dayjs.locale('nb');

export const getDay = (date) => dayjs(date).format('YYYY-MM-DD');
export const getTime = (date) => dayjs(date).format('HH.mm');

export const isAfter = (datefrom, dateTo) => dayjs(datefrom).isAfter(dateTo);

export const isMobile = () => {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    return true;
  }
  return false;
};


/**
 * Takes the location url of the chat client and matches against mappings. Mappings has an id and list of urls mapping to that id.
 * @param {*} chatUrl location URL of chat client
 * @param {*} mappings id is the id of the chat room, urls are the list of urls mapping to that id.
 */
 export const getChannelIdFromUrl = (chatUrl, mappings) => {
  let star;
  mappings.map(mapping =>
    mapping.urls.map(url => {
      if (url.includes('*') && url.replace('*', '') === chatUrl) {
        star = { id: mapping.id, url: url };
      }
    }),
  );

  if (star && star.id) {
    return star.id;
  } else {
    const hit = mappings
      .filter(mapping => mapping.urls.some(url => chatUrl.startsWith(url)))
      .map(mapping => {
        const urlHit = mapping.urls.filter(url => chatUrl.startsWith(url));
        return { id: mapping.id, url: urlHit[0] };
      })
      .sort((m1, m2) => m2.url.length - m1.url.length);

    if (hit.length) {
      return hit[0].id;
    }
  }
  return '';
};